import { ContainerModule } from '@evertel/di'


export const DI_WEB_HEADER_MODULE = [
    new ContainerModule(() => {
        // Header-level DI bindings (currently empty)
    })
]
